import type { Degree } from "../units/Units"
import type { PlotFunction } from "./PlotFunction"

// Base type for common properties
export type BasePlotObject = {
  enum: PlotFunction
  rotation?: Degree
}

// Base type for common properties
export type ConcretePlotObject = {
  fill_color?: string
  stroke_color?: string
} & BasePlotObject
